import { enum as _enum, object, z, string, union, literal, date } from 'zod';

// src/schema.ts
var roleSchema = _enum(["admin", "manage", "user"]);
var transformSchema = object({
  rotate: z.number().multipleOf(90).min(-360).max(360).default(0).transform((val) => (val % 360 + 360) % 360),
  scale: z.number().min(0.1).max(5).default(1)
});
var accountSchema = object({
  id: string().brand(),
  displayName: string().nullish().transform((v) => {
    if (v === null || v === void 0 || v === "") {
      return "\u672A\u8A2D\u5B9A";
    }
    return v;
  }),
  roles: roleSchema.array(),
  photoURL: string().url().nullish(),
  loginMethod: _enum(["twitter", "google", "password"]).nullish()
});
var userSchema = object({
  id: accountSchema.shape.id,
  firstName: string(),
  lastName: string(),
  kana: object({
    firstName: string(),
    lastName: string()
  }),
  email: string().email(),
  tel: string(),
  address: object({
    postcode: string(),
    state: string(),
    city: string(),
    address1: string(),
    address2: string().optional()
  }),
  birthday: date(),
  work: string(),
  bank: object({
    name: string(),
    branch: string(),
    symbol: string().optional(),
    // 銀行コード（4桁）: 既存ドキュメントには存在しないため optional
    code: string().optional(),
    // 支店番号（3桁）: 既存ドキュメントには存在しないため optional
    branchCode: string().optional(),
    accountType: union([literal(1), literal(2)]),
    accountNumber: string(),
    accountHolder: string()
  })
});
var chatMessageSchema = object({
  id: string(),
  text: string(),
  createdAt: date(),
  author: accountSchema.pick({ id: true, displayName: true }).merge(z.object({ photoURL: z.string().nullable() })),
  readAt: date().optional(),
  images: z.array(z.string()).optional().default([])
});
var kycSchema = object({
  id: string().brand(),
  front: string().url(),
  frontTransform: transformSchema.optional().default({ rotate: 0, scale: 1 }),
  back: string().url(),
  backTransform: transformSchema.optional().default({ rotate: 0, scale: 1 }),
  face: string().url(),
  faceTransform: transformSchema.optional().default({ rotate: 0, scale: 1 }),
  verify: _enum(["pending", "verified", "reject"]),
  createdAt: date()
});
var transactionBaseSchema = object({
  id: string().brand(),
  author: userSchema,
  status: _enum(["pending", "wip", "transfer", "reject", "done"]),
  requestedAt: date(),
  requestImages: string().array(),
  requestImageTransform: transformSchema.array().optional(),
  note: string(),
  // 承諾確認メール送信済み（Cloud Function send_start_transaction_mail が設定）
  confirmedAt: date().optional(),
  // 顧客が「買取品を発送」を押した日時
  shippedAt: date().optional(),
  // 工房が「商品確認」を押した日時
  checkedAt: date().optional()
});
var transactionSchema = transactionBaseSchema.transform((data) => {
  var _a;
  const images = data.requestImages;
  const transforms = (_a = data.requestImageTransform) != null ? _a : images.map(() => ({ rotate: 0, scale: 1 }));
  return { ...data, requestImageTransform: transforms };
});
var globalNotice = object({
  id: string().brand(),
  type: literal("global"),
  content: string()
});
var unReadChatMessageNotice = object({
  id: string().brand(),
  type: literal("new-chat-message"),
  content: string(),
  payload: object({
    user: userSchema.pick({ id: true }),
    transaction: transactionBaseSchema.pick({ id: true }),
    chatMessage: chatMessageSchema.pick({ id: true })
  })
});
var noticeSchema = z.discriminatedUnion("type", [globalNotice, unReadChatMessageNotice]);

export { accountSchema, chatMessageSchema, kycSchema, noticeSchema, roleSchema, transactionBaseSchema, transactionSchema, transformSchema, userSchema };
//# sourceMappingURL=chunk-2CIDNLJ5.mjs.map
//# sourceMappingURL=chunk-2CIDNLJ5.mjs.map